import React from "react";
import "./Loader.css"; // make sure to include the CSS below

const Loader = () => {
  return <div className="pulse-spinner"></div>;
};

export default Loader;
